module.exports = __webpack_public_path__ + "img/img3-5.12b15742.png";